// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"759":"ebb36d70","951":"e6313639"}[chunkId] + ".js";
};